import { CSSProperties } from 'react';
import { LoadIndicatorView } from './load-indicator.view';
import { LoadIndicatorSizeEnum } from '@vivli/shared/infrastructure/enum';

const containerStyle: CSSProperties = {
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
};

export const LoadIndicatorCenteredView = ({ message }: { message?: string }) => {
    return (
        <div style={containerStyle}>
            <LoadIndicatorView size={LoadIndicatorSizeEnum.Medium} message={message} />
        </div>
    );
};
